<template>
  <main>
    <vue-headful
      :title="'Enjoj | ' + surrounding.name + ' - Afspraken'"
      :description="surrounding.description"
      :image="surrounding.banner"
    />
    <ec-page-heading
      :paragraph="paragraph"
      :sub-title="subTitle"
      :title="pageTitle"
      class="intro-text wrapper pt-5 pb-5"
    />
    <div class="container my-5">
      <section class="step-busines" v-if="businesses.length > 0">
        <StepHeader
          :step="1"
          :total="5"
          title="Bedrijven"
          subTitle="Kies jouw winkel of bedrijf"
        />
        <Carousel
          :perPageCustom="breakpoints"
          ref="dates"
          class="business-corousel"
        >
          <Slide
            v-for="(business, index) in businesses"
            class="business px-2"
            :class="{ active: index === businessIndex }"
            @slideclick="getTypes(index)"
            :key="index"
          >
            <div class="business-inner">
              <div
                :style="{ backgroundImage: `url(${business.banner_url})` }"
                class="business-inner__top mb-3 position-relative"
              >
              </div>
            </div>
            <div class="business-inner__bottom position-relative">
              <h4 class="mb-1">{{ business.text }}</h4>
              <div class="business-inner__distance d-flex ">
                <i class="icon enjoj-pin mr-1"></i>
                <span class="align-self-center">{{ getDistance(business.gps.data) }} km</span>
              </div>
              <i class="enjoj-arrow-right position-absolute business-inner__icon"></i>
            </div>
          </Slide>
        </Carousel>
      </section>
      <Dates
        v-if="types.length > 0"
        style="z-index: 100;"
        :types="types"
        onEnjoj
      />
      <transition name="fade">
        <div class="message-step loading-step py-3 px-4" v-if="loading">
          <p>Stap 1 aan het laden <span>.</span><span>.</span><span>.</span></p>
        </div>
        <div class="message-step error-step py-3 px-4" v-if="feedback">
          <p>{{ feedback }}</p>
        </div>
      </transition>
    </div>
  </main>
</template>

<script>
import { mapState } from 'vuex'
import ecPageHeading from '@/components/General/PageHeading'
import StepHeader from '@/components/Dates/Header'
import { Carousel, Slide } from 'vue-carousel'
import Location from '@/mixins/Location'
import Utilities from '@/mixins/Utilities'
import Distance from '@/mixins/Distance'
import Dates from '@enjoj/dates'
import '@enjoj/dates/package/dist/dates.css'

export default {
  name: 'ec-dates-index',
  components: {
    Dates,
    ecPageHeading,
    StepHeader,
    Carousel,
    Slide
  },
  mixins: [Utilities, Location, Distance],
  data () {
    return {
      loading: false,
      feedback: null,
      businessIndex: null,
      breakpoints: [
        [0, 2],
        [768, 3],
        [992, 4],
        [1200, 5]
      ],
      businesses: [],
      types: []
    }
  },
  computed: {
    ...mapState([
      'surroundingLoaded',
      'surrounding'
    ]),
    pageTitle () {
      return 'Afspraken'
    },
    paragraph () {
      return 'Volg onderstaande stappen om jouw afspraak te maken'
    },
    subTitle () {
      return 'Maak eenvoudig en snel je afspraak!'
    }
  },
  methods: {
    setData () {
      this.feedback = null
      this.loading = true
      this.$http.get(`https://beta.enjoj-test.nl/api/community/${this.surrounding.id}/dates/surroundings`).then(res => {
        const surroundings = res.body.data
        surroundings.forEach(surrounding => {
          let types = surrounding.date_types.data
          types = types.filter(type => !type.name.includes('Afhaaltijden '))
          if (types.length > 0) {
            this.businesses.push({ ...surrounding, date_types: types })
          }
        })
        if (this.businesses.length <= 0) {
          this.feedback = 'Geen afspraken in de omgeving'
        }
        this.loading = false
      }).catch(() => {
        this.loading = false
        this.feedback = 'Oh! foutje :('
      })
    },
    getTypes (index) {
      this.types = []
      this.feedback = null
      setTimeout(() => {
        this.types = this.businesses[index].date_types
      }, 500)
      this.businessIndex = index
    }
  },
  beforeRouteEnter (to, from, next) {
    if (from.name === null) {
      next(vm => {
        vm.getSiteData()
      })
    } else {
      next(vm => {
        if (vm.surroundingLoaded) {
          vm.setData()
        }
      })
    }
  },
  watch: {
    surroundingLoaded (condition) {
      if (condition) {
        this.$store.commit('setIsLoading', false)
        this.setData()
      }
    }
  }
}
</script>
